
export default {
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    size: {
      type: String,
      default: null
    }
  },
  vessel: {
    label: {
      '$attrs': 'all'
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locales.find((item) => {
        return item.code === this.$i18n.locale
      })
    },
    locales() {
      return this.$i18n.locales.filter((item) => {
        return item.code !== this.$i18n.locale
      })
    }
  },
  methods: {
    changeLocale(locale) {
      const meta = this.$seoMeta.params[locale]
      const path = this.switchLocalePath(locale, meta)

      this.$router.push({ path })
    },
    switchLocalePath(locale, routeParams) {
      const name = this.getRouteBaseName(this.$route)
      if (!name) return ''

      const { params, ...routeCopy } = this.$route

      const baseRoute = Object.assign({}, routeCopy, {
        name,
        params: {
          ...params,
          ...routeParams,
          0: params.pathMatch
        }
      })

      return this.localePath(baseRoute, locale)
    }
  }
}
